import {
	Component,
	ElementRef,
	OnInit,
	ViewChild,
	ViewEncapsulation
} from '@angular/core';

declare let d3;

import { SpeakerService } from '../speaker.service';


@Component({
	selector: 'scatter',
	/* template: `
	 <button type="button" class="btn btn-primary" (click)="speakerSrv.changeView('RES', $event)"><i class="fa fa-chevron-left" aria-hidden="true"></i>
   Back</button>
	 <div>
	   <nvd3 [options]='options' [data]='data'></nvd3>
	 </div>`,*/
	templateUrl: './scatter.component.html',
	styleUrls: ['./scatter.component.css'],
	encapsulation: ViewEncapsulation.None
})

export class ScatterChartComponent implements OnInit {
	@ViewChild('scatter') scatter: ElementRef;
	options;
	data;
	
	genderKeys = ['m', 'f'];
	
	plotData;
	
	constructor(private speakerSrv: SpeakerService) { }
	
	public Male1994Abs = 0;
	public Female1994Abs = 0;
	public Male2014Abs = 0;
	public Female2014Abs = 0;
	
	public Male1994 = 0;
	public Female1994 = 0;
	public Male2014 = 0;
	public Female2014 = 0;
	public male1994Count = 0;
	public female1994Count = 0;
	public male2014Count = 0;
	public female2014Count = 0;
	
	public loaded: boolean = false;
	
	public barColors: any[];
	
	public labels: string[] = ["Male", "Female"];
	
	ngOnInit() {
		this.speakerSrv.statsChange.subscribe(stats => { this.update(stats); });
		this.options = {
			scales: {
				yAxes: [
					{ ticks: {
							beginAtZero: true
						},
						scaleLabel: {
							display: true,
							labelString: 'Relative Frequency per 10,000'
						}
					}
				]
			},
			tooltips: {
				enabled: true,
				mode: 'single',
				displayColors: false,
				callbacks: {
					label: (tooltipItem, data) => {
						//let label = data.labels[tooltipItem.index];
						let datasetLabel = Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]);
						let absVal;
						if (tooltipItem.datasetIndex == 0) {
							if (tooltipItem.index == 0) {
								absVal = this.Male1994Abs;
							} else {
								absVal = this.Female1994Abs;
							}
						} else {
							if (tooltipItem.index == 0) {
								absVal = this.Male2014Abs;
							} else {
								absVal = this.Female2014Abs;
							}
						}
						
						return [
							SpeakerService.numberFormat(datasetLabel, 2),
							'(' + SpeakerService.numberFormat(absVal) + ')'
						];
					}
				}
			}
		};
		
		this.barColors = [];
		
		let ctx = this.scatter.nativeElement.getContext('2d');
		let grad1 = ctx.createLinearGradient(0, 0, 0, 200);
		grad1.addColorStop(0, '#c47eee');
		grad1.addColorStop(1, '#e86dd0');
		
		let grad2 = ctx.createLinearGradient(0, 0, 0, 200);
		grad2.addColorStop(0, '#d3f77f');
		grad2.addColorStop(1, '#eac26c');
		
		this.barColors.push({backgroundColor: grad1, hoverBackgroundColor: grad1});
		this.barColors.push({backgroundColor: grad2, hoverBackgroundColor: grad2});
		
	}
	
	update(stats) {
		this.loaded = false;
	
		this.Male1994Abs = 0;
		this.Female1994Abs = 0;
		this.Male2014Abs = 0;
		this.Female2014Abs = 0;
		
		this.Male1994 = 0;
		this.Female1994 = 0;
		this.Male2014 = 0;
		this.Female2014 = 0;
		this.male1994Count = 0;
		this.female1994Count = 0;
		this.male2014Count = 0;
		this.female2014Count = 0;
		
		
		let data = { labels: ['Candidate', 'Examiner'] };
		// If array is not empty
		if (Object.keys(stats).length > 0) {
			
			let keys = this.genderKeys;
			
			// Create an object that has the total value of all the keys added together
			var obj = keys.reduce(function(acc, cur, i) {
				acc[cur] = 0;
				return acc;
			}, {});
			
			
			// Assign Corpus Total Dictionary to categorise data.
			let corpusTotal = { 'Candidate': Object.assign({}, obj), 'Examiner': Object.assign({}, obj) };
			//for each dataset
			for (let i = data.labels.length - 1; i >= 0; i--) {
				
				let l = data.labels[i];
				
				const objKeys = Object.keys(stats[l]);
				
				// for each entry
				for (let j = objKeys.length - 1; j >= 0; j--) {
					let g = stats[l][objKeys[j]];
					
					//       console.log(g);
					
					if (g['gender'] == 'male' && i == 1) {
						this.Male2014 += g['relative'];
						this.male2014Count = this.male2014Count + 1;
						this.Male2014Abs += g['count'];
						//      console.log('M14');
					} else if (g['gender'] == 'female' && i == 1) {
						this.Female2014 += g['relative'];
						this.female2014Count = this.female2014Count + 1;
						this.Female2014Abs += g['count'];
						//      console.log('F14');
					} else if (g['gender'] == 'male' && i == 0) {
						this.Male1994 += g['relative'];
						this.male1994Count = this.male1994Count + 1;
						this.Male1994Abs += g['count'];
						//      console.log('M94');
					} else if (g['gender'] == 'female' && i == 0) {
						this.Female1994 += g['relative'];
						this.female1994Count = this.female1994Count + 1;
						this.Female1994Abs += g['count'];
						//           console.log('F94');
					}
				}
			}
			
		}
		this.Male1994 = this.Male1994 / this.male1994Count;
		this.Female1994 = this.Female1994 / this.female1994Count;
		this.Male2014 = this.Male2014 / this.male2014Count;
		this.Female2014 = this.Female2014 / this.female2014Count;
		this.data =  [
			{
				data: [this.Male1994, this.Female1994],
				label: 'Candidate'
			},
			//backgroundColor: ["#c47eee", "#e86dd0"]},
			{
				data: [this.Male2014, this.Female2014],
				label: 'Examiner'//,
				//      backgroundColor: ["#d3f77f", "#eac26c"]//"rgb(255, 127, 14)"
			}
		];
		this.loaded = true;
	}
	
	
	chartClicked(event: any) {
		console.log(event);
		if (event.active.length > 0) {
			let chartElement = event.active[0]._chart.getElementAtEvent(event.event);
			console.log(chartElement[0]._model.datasetLabel);
			let newEvent = {
				element: {
					_model: {
						datasetLabel: chartElement[0]._model.datasetLabel,
						label: chartElement[0]._model.label
					}
				}
			};
			this.speakerSrv.concordanceGenderFilter.next(newEvent);
			this.speakerSrv.changeView('Concordance', event);
		}
	}
}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/scatter/scatter.component.ts